import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'

import { Gantt } from 'gantt-task-react'
import 'gantt-task-react/dist/index.css'

import useViewModel from './ViewModel'

const ProjectGanttChartView: React.FC = () => {
  const { tasks } = useViewModel()

  return (
    <ViewPageTitle>
      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        {/* begin:: Gantt Chart */}
        <div className='col-12'>
          <div className='card'>
            <div className='card-body'>{tasks.length && <Gantt tasks={tasks} />}</div>
          </div>
        </div>
        {/* end:: Gantt Chart */}
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/project',
            title: 'Project',
            icon: '/media/icons/duotune/general/gen005.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'Gantt Chart',
          },
        ]}>
        Project Gantt Chart
      </PageTitle>

      {children}
    </>
  )
}

export default ProjectGanttChartView
